// extracted by mini-css-extract-plugin
export default {"size-1em":"QDC2s76IUyQbuDNkeVcL","size-1_5em":"QeOeoO9e5z54Cz7yvqrw","size-2em":"Z5WPSdaQlCxhW_gMvvwc","size-1rem":"VV7w7CwMujRF4py8v0N9","size-1_25rem":"Bq5P0GYpZhi29a_vOcMh"};